import { NS_CONFIGURATION, PROJECT, EDITOR, BOARD, CURRENT } from 'redux/constants';
import { action, createType, ASYNC, SYNC } from 'redux-create-type';


export const {
  INIT,
  SET_NAME,
  SET_IS_ACTIVE,
  SET_ORDER,
  SET_IS_SPRINT_BOARD,
  SET_TIMELINE_TYPE,
  SET_IS_GROUPED_BOARD,
  INVALIDATE_CHANGES,
  SET_REMOVED,
  ADD_COLUMN,
  REMOVE_COLUMN,
  ADD_ROW,
  REMOVE_ROW,
  SET_ITEM_TYPE,
  SET_STATYS,
  SET_COLUMN_NAME,
  SET_GROUP_ITEM_TYPE,
  CHECK_VALIDATION,
  RESET_HIGHLIGHTS,
  EMPTY
} = createType(NS_CONFIGURATION, PROJECT, EDITOR, BOARD, CURRENT)({
    INIT: ASYNC,
    SET_NAME: SYNC,
    SET_IS_ACTIVE: SYNC,
    SET_ORDER: SYNC,
    SET_IS_SPRINT_BOARD: SYNC,
    SET_TIMELINE_TYPE: SYNC,
    SET_IS_GROUPED_BOARD: ASYNC,
    INVALIDATE_CHANGES: SYNC,
    SET_REMOVED: SYNC,
    ADD_COLUMN: ASYNC,
    REMOVE_COLUMN: ASYNC,
    ADD_ROW: ASYNC,
    REMOVE_ROW: ASYNC,
    SET_ITEM_TYPE: ASYNC,
    SET_STATYS: ASYNC,
    SET_COLUMN_NAME: ASYNC,
    SET_GROUP_ITEM_TYPE: ASYNC,
    CHECK_VALIDATION: ASYNC,
    RESET_HIGHLIGHTS: SYNC,
    EMPTY: SYNC
  });


export const init = {
  begin: localId => action(INIT.BEGIN, { localId }),
  end: ({ selectedValue, columnOptions }) => action(INIT.END, { selectedValue, columnOptions }),
};
export const setName = name => action(SET_NAME, { name });
export const resetHighlights = () => action(RESET_HIGHLIGHTS);
export const setIsActive = value => action(SET_IS_ACTIVE, { value });
export const setOrder = order => action(SET_ORDER, { order });
export const setIsSprintBoard = value => action(SET_IS_SPRINT_BOARD, { value });
export const setTimelineType = value => action(SET_TIMELINE_TYPE, { value });
export const setIsGroupedBoard = {
  begin: value => action(SET_IS_GROUPED_BOARD.BEGIN, { value }),
  end: ({ columns, columnOptions }) => action(SET_IS_GROUPED_BOARD.END, { columns, columnOptions }),
};
export const setRemoved = value => action(SET_REMOVED, { value });
export const invalidateChanges = ({ changes }) => action(INVALIDATE_CHANGES, { changes });
export const addColumn = {
  begin: () => action(ADD_COLUMN.BEGIN),
  end: ({
    columnOptions,
    }) => action(ADD_COLUMN.END, {
      columnOptions,
    }),
};
export const removeColumn = {
  begin: columnId => action(REMOVE_COLUMN.BEGIN, { columnId }),
  end: ({
    columnOptions,
    }) => action(REMOVE_COLUMN.END, {
      columnOptions,
    }),
};
export const addRow = {
  begin: columnId => action(ADD_ROW.BEGIN, { columnId }),
  end: ({
    columnOptions,
    highlights,
    }) => action(ADD_ROW.END, {
      columnOptions,
      highlights
    }),
};
export const removeRow = {
  begin: ({ columnId, itemTypeConfigId }) => action(REMOVE_ROW.BEGIN, { columnId, itemTypeConfigId }),
  end: ({
    columnOptions,
    }) => action(REMOVE_ROW.END, {
      columnOptions,
    }),
};
export const setItemType = {
  begin: ({ columnId, curentItemTypeConfigId, newItemTypeConfigId }) => action(SET_ITEM_TYPE.BEGIN, { columnId, curentItemTypeConfigId, newItemTypeConfigId }),
  end: ({
    columnOptions,
    highlights,
    }) => action(SET_ITEM_TYPE.END, {
      columnOptions,
      highlights,
    }),
};
export const setStatus = {
  begin: ({ columnId, itemTypeConfigId, statusId }) => action(SET_STATYS.BEGIN, { columnId, itemTypeConfigId, statusId }),
  end: ({
    columnOptions,
    highlights,
    }) => action(SET_STATYS.END, {
      columnOptions,
      highlights,
    }),
};
export const setColumnName = {
  begin: ({ columnId, name }) => action(SET_COLUMN_NAME.BEGIN, { columnId, name }),
  end: ({
    columnOptions,
    }) => action(SET_COLUMN_NAME.END, {
      columnOptions,
    }),
};
export const setGroupItemType = {
  begin: ({ oldItemTypeConfigId, newItemTypeConfigId }) => action(SET_GROUP_ITEM_TYPE.BEGIN, { oldItemTypeConfigId, newItemTypeConfigId }),
  end: ({ columnOptions }) => action(SET_GROUP_ITEM_TYPE.END, { columnOptions }),
};
export const checkValidation = {
  begin: () => action(CHECK_VALIDATION.BEGIN, { }),
  end: ({ errors }) => action(CHECK_VALIDATION.END, { errors }),
};
export const empty = () => action(EMPTY);


// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/board/currentBoard/actions.js